import { HistoryResponseType, SocialMediaPost, useGetSocialAttributes } from "../../api/play-api"
import Attributes from "../Attributes"
import GeneratedPostCard from "../GeneratedPostCard"

type HistoryResultsProps = {
  eventId: number,
  playHistoryData: HistoryResponseType
}

const HistoryResults = ({eventId, playHistoryData}: HistoryResultsProps) => {
  const { postAttributes } = useGetSocialAttributes(eventId)
    const eventNameDesc = (data: HistoryResponseType, id: number): {name: string, description: string| null} => {
    const foundEvent = data.data.findIndex(event => event.event_id === id)
    return {name: data.data[foundEvent].event_name, description: data.data[foundEvent].event_description}
  }

  const eventPosts = (data: HistoryResponseType, id: number): SocialMediaPost[] => {
    const foundEvent = data.data.findIndex(event => event.event_id === id)
    return data.data[foundEvent].posts
  }
  return (
    <div className="w-full flex flex-col px-10">
      <h2 className="text-2xl font-semibold font-montserrat pt-8">{eventNameDesc(playHistoryData, eventId).name}</h2>
      <p className="text-gray-600 pb-8">{eventNameDesc(playHistoryData, eventId).description}</p>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-3 pb-4 gap-4">
        {eventPosts(playHistoryData, eventId).map(content => (
          <GeneratedPostCard
            cta={content.cta}
            text={content.text}
            hashtags={content.hashtags}
            platform={content.platform}
            key={content.text}
            date_of_posting={content.date_of_posting}
            time_of_posting={content.time_of_posting}
            image_video_recommendations={content.image_video_recommendations} />
        ))}
      </div>
      {postAttributes && <Attributes brandAttributes={postAttributes.attributes_brands} eventAttributes={postAttributes.attribute_events} />}

    </div>

  )
}

export default HistoryResults

